import "./styles.scss";
import { isPlatform } from "@ionic/core";
import { getValidChildren } from "@src/utils/react-general.util";
import { Children, ReactNode, useEffect, useRef } from "react";
/**
 *
 * @description this toast function aims to have a all the features that a toast has with React element support
 */
type CBHToastProps = {
  isOpen: boolean;
  children?: ReactNode;
  onDidDismiss?: Function;
  message?: string;
};
/**
 * @deprecated Use `useToast`
 */
export function CBHToast({ isOpen, onDidDismiss, message, children }: CBHToastProps) {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const isIOS = isPlatform("ios");
  useEffect(() => {
    if (isOpen) {
      timeoutRef.current = setTimeout(() => {
        if (onDidDismiss) {
          onDidDismiss();
        }
      }, 15000);
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isOpen, onDidDismiss]);
  return (
    <div
      className={`cbh-toast-container ${isOpen ? `is-toast-visible` : `is-toast-not-visible`} ${
        isIOS ? `toast-for-ios` : `toast-for-android`
      } ion-toast ion-color-danger`}
    >
      <div className="toast-container">
        <div className="toast-content">
          {Children.count(getValidChildren(children)) ? (
            children
          ) : (
            <div className="toast-message">{message}</div>
          )}
        </div>
      </div>
    </div>
  );
}
